import { render } from "./TakeSnapshot.vue?vue&type=template&id=87d6cbe0&scoped=true"
import script from "./TakeSnapshot.vue?vue&type=script&lang=js"
export * from "./TakeSnapshot.vue?vue&type=script&lang=js"

import "./TakeSnapshot.vue?vue&type=style&index=0&id=87d6cbe0&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87d6cbe0"]])

export default __exports__